// extracted by mini-css-extract-plugin
module.exports = {"container":"_1XHLE","input":"_1Js1p","borders":"_2xVNI"};